<div fxLayout="column" *ngIf="hasLoaded">

    <mat-card>
        <mat-card-content>
            <div fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" class="p-10 text-danger">
                <mat-icon>warning</mat-icon>
                <span>DO NOT create or edit a product replacement tags without discussing and understanding the ramifications of the change.</span>
                <mat-icon>warning</mat-icon>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-header>
            <mat-card-title>Product Replacement Tags</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form>
              <div class="m-b-20">
                This page is used to create and edit 'general' tags that are used by BimViewer. These tags must be added to the appropriate class in <i>IfcToJson.Contracts</i>.
                Read more about tags in the <a href="https://app.clickup.com/18617051/v/dc/hr4pv-6342" target="_blank">documentation</a>.
              </div>

              <div class="m-b-20">
                If you need to add a new product type, go to <a routerLink="/products/categorization">Product Categorization</a>.
              </div>

              <mat-form-field>

                <input matInput type="text" placeholder="Select Product Replacement Tag" [formControl]="tagControl" [matAutocomplete]="tagAuto">
                <button mat-button *ngIf="tagControl.value || selectedThemeReplacementTag" matSuffix mat-icon-button aria-label="Clear" (click)="onClearTag()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #tagAuto="matAutocomplete" [displayWith]="displayReplacementTagTag" (optionSelected)="onTagSelected($event.option.value)">
                  <mat-option *ngFor="let replacementTag of filteredTags | async" [value]="replacementTag">
                      <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                        <span [innerHtml]="replacementTag.tag | encodeHtml | highlight: tagControl.value"></span>
                      </div>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </form>

            <mat-card *ngIf="!selectedThemeReplacementTag" class="contrast">
                <mat-card-content fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="15px">
                    <div>Select a Product Replacement Tag</div>
                    <div><b>OR</b></div>
                    <button type="button" mat-flat-button (click)="createProductReplacementTag()">
                        <mat-icon>add</mat-icon> Create New Product Replacement Tag
                    </button>
                </mat-card-content>
            </mat-card>

            <mat-card *ngIf="selectedThemeReplacementTag" class="contrast">
                <mat-card-header>
                    <mat-card-title *ngIf="!isNew">
                        {{ selectedThemeReplacementTag.tag }}
                    </mat-card-title>
                    <mat-card-title *ngIf="isNew">
                        Create New Tag
                    </mat-card-title>

                </mat-card-header>
                <mat-card-content>

                    <div *ngIf="isNew" class="w-100">
                        <mat-form-field>
                            <mat-label>Product Replacement Tag</mat-label>
                            <input matInput type="text" [(ngModel)]="selectedThemeReplacementTag.tag">
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="20px">

                        <div class="w-100">
                            <div class="m-b-5">
                                Orders 'tag by product' and 'product by tag' selection in the theming interface.
                            </div>
                            <mat-form-field>
                                <mat-label>Related Product Types</mat-label>
                                <mat-chip-list #chipListProductType aria-label="Related Product Types">
                                <mat-chip
                                    *ngFor="let productTypeId of selectedThemeReplacementTag.productTypeIds"
                                    [selectable]="true"
                                    [removable]="true"
                                    (removed)="onRemoveProductType(productTypeId)">
                                    {{ getProductType(productTypeId)?.name }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                                <input
                                    #productTypeInput
                                    [matAutocomplete]="productTypeAuto"
                                    [formControl]="productTypesControl"
                                    [matChipInputFor]="chipListProductType"
                                    [matChipInputSeparatorKeyCodes]="[13, 188]"
                                    [matChipInputAddOnBlur]="false"
                                />
                                </mat-chip-list>
                                <mat-autocomplete #productTypeAuto="matAutocomplete" (optionSelected)="onProductTypeSelected($event.option.value)">
                                <mat-option *ngFor="let productType of filteredProductTypes | async" [value]="productType.id">
                                    <span [innerHtml]="productType.name | encodeHtml | highlight: productTypesControl.key"></span>
                                </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>

                        <div class="w-100">
                            <div class="m-b-5">
                                The type of theme line item that this tag can be used with.
                            </div>
                            <mat-form-field>
                                <mat-label>Related Theme Line Item Types</mat-label>
                                <mat-chip-list #chipListThemeLineItemType aria-label="Related Theme Line Item Types">
                                <mat-chip
                                    *ngFor="let themeLineItemTypeId of selectedThemeReplacementTag.themeLineItemTypeIds"
                                    [selectable]="true"
                                    [removable]="true"
                                    (removed)="onRemoveThemeLineItemType(themeLineItemTypeId)">
                                    {{ getThemeLineItemType(themeLineItemTypeId)?.name }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                                <input
                                    #themeLineItemTypeInput
                                    [matAutocomplete]="themeLineItemTypeAuto"
                                    [formControl]="themeLineItemTypesControl"
                                    [matChipInputFor]="chipListThemeLineItemType"
                                    [matChipInputSeparatorKeyCodes]="[13, 188]"
                                    [matChipInputAddOnBlur]="false"
                                />
                                </mat-chip-list>
                                <mat-autocomplete #themeLineItemTypeAuto="matAutocomplete" (optionSelected)="onThemeLineItemTypeSelected($event.option.value)">
                                <mat-option *ngFor="let themeLineItemType of filteredThemeLineItemTypes | async" [value]="themeLineItemType.id">
                                    <span [innerHtml]="themeLineItemType.name | encodeHtml | highlight: themeLineItemTypesControl.key"></span>
                                </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        
                    </div>
                    
                    <button type="button" mat-flat-button color="accent" (click)="saveProductReplacementTag()" [disabled]="!selectedThemeReplacementTag">
                        <mat-icon>done</mat-icon> Save
                    </button>

                </mat-card-content>
            </mat-card>

        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-header>
            <mat-card-title>Theme Line Item Types</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="m-b-20">
                A theme line item type tells the theming system which asset template a theme line item uses, and which replacement tag group it can target.
                <br>
                A replacement tag group decides which replacement tags a line item of this type can use, and which other types it can be swapped with in a theme.
            </div>

            <form>
              <mat-form-field>

                <input matInput type="text" placeholder="Select Theme Line Item Type" [formControl]="editThemeLineItemTypeControl" [matAutocomplete]="editThemeLineItemTypeAuto">
                <button mat-button *ngIf="editThemeLineItemTypeControl.value || selectedThemeLineItemType" matSuffix mat-icon-button aria-label="Clear" (click)="onClearEditThemeLineItemType()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #editThemeLineItemTypeAuto="matAutocomplete" [displayWith]="displayThemeLineItemTypeName" (optionSelected)="onEditThemeLineItemTypeSelected($event.option.value)">
                  <mat-option *ngFor="let themeLineItemType of filteredEditThemeLineItemTypes | async" [value]="themeLineItemType">
                      <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                        <span [innerHtml]="themeLineItemType.name | encodeHtml | highlight: editThemeLineItemTypeControl.value"></span>
                      </div>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </form>

            <mat-card *ngIf="!selectedThemeLineItemType" class="contrast">
                <mat-card-content fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="15px">
                    <div>Select a Theme Line Item Type</div>
                    <div><b>OR</b></div>
                    <button type="button" mat-flat-button (click)="createThemeLineItemType()">
                        <mat-icon>add</mat-icon> Create New Theme Line Item Type
                    </button>
                </mat-card-content>
            </mat-card>

            <mat-card *ngIf="selectedThemeLineItemType" class="contrast">
                <mat-card-header>
                    <mat-card-title *ngIf="!isNewThemeLineItemType">
                        {{ selectedThemeLineItemType.name }}
                    </mat-card-title>
                    <mat-card-title *ngIf="isNewThemeLineItemType">
                        Create New Theme Line Item Type
                    </mat-card-title>

                </mat-card-header>
                <mat-card-content>

                    <div *ngIf="isNewThemeLineItemType" class="w-100">
                        <mat-form-field>
                            <mat-label>Name</mat-label>
                            <input matInput type="text" [(ngModel)]="selectedThemeLineItemType.name" required>
                            <mat-hint>The name can't be changed once the type is created.</mat-hint>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="20px">
                        <mat-form-field class="w-100">
                            <mat-label>Template Name</mat-label>
                            <input matInput type="text" [(ngModel)]="selectedThemeLineItemType.templateName" required>
                        </mat-form-field>

                        <mat-form-field class="w-100">
                            <mat-label>Replacement Tag Group</mat-label>
                            <input matInput type="text" [(ngModel)]="selectedThemeLineItemType.themeReplacementTagGroup">
                        </mat-form-field>
                    </div>

                    <button type="button" mat-flat-button color="accent" (click)="saveThemeLineItemType()" [disabled]="!selectedThemeLineItemType">
                        <mat-icon>done</mat-icon> Save
                    </button>

                </mat-card-content>
            </mat-card>
        </mat-card-content>
    </mat-card>

</div>